import { FC, Suspense } from 'react';

import { Loading } from '@portal/common/components';
import { styled } from '@portal/common/theme';

import Navigation from '../components/Navigation';

const Container = styled('div')({
    display: 'flex',
    flexFlow: 'row nowrap',
    height: '100vh',
    // TODO: remove minWidth with responsive design
    minWidth: 1200,
});

const Body = styled('div')({
    flexGrow: 1,
});

const LayoutWithSidenav: FC = ({ children }) => (
    <Container>
        <Navigation />
        <Body>
            <Suspense fallback={<Loading />}>{children}</Suspense>
        </Body>
    </Container>
);

export default LayoutWithSidenav;
